import LoadingButton from '@components/LoadingButton.tsx';
import { ComponentName } from '@constants';
import { useAuth } from '@hooks/useAuth.tsx';
import { useI18n } from '@hooks/useI18n.tsx';
import { enableModal } from '@state/reducers/modals.ts';
import { setDisableLogoutModal, setLogout } from '@state/reducers/user.ts';
import GenericModal from '@v2/components/modals/GenericModal.tsx';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketPlayerDisabledWatcher() {
  const { getLatest } = useSocket();
  const { t, jsxT } = useI18n();
  const [showModal, setShowModal] = useState<boolean>(false);
  const history = useHistory();
  const { signout } = useAuth();
  const dispatch = useDispatch();
  const playerDisabled = getLatest('player_disabled');

  const doLogout = () => {
    signout().then(() => {
      dispatch(setLogout());
      setShowModal(false);
      history.push('/');
    });
  };

  const lastEventKeyRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (playerDisabled) {
      // @ts-ignore
      const eventKey = `${playerDisabled.action}:${playerDisabled.data?.player_id ?? 'unknown'}`;

      if (lastEventKeyRef.current === eventKey) return;
      lastEventKeyRef.current = eventKey;
      setShowModal(true);
    }
  }, [history, playerDisabled]);

  return (
    <GenericModal
      isCentered
      show={showModal}
      withoutClose={true}
      preventEscClose={true}
      preventBluringClose={true}
      hideCallback={() => {
        doLogout();
        lastEventKeyRef.current = null;
      }}
      className="pb-5"
    >
      <h2 className="mb-2">{t('player_disable_modal_title')}</h2>
      <p className="mb-3">{jsxT(`player_disable_modal_desc`)}</p>
      <div className="d-flex justify-content-end gap-2 mt-5">
        <LoadingButton
          className="w-30"
          variant="primary"
          onClick={() => {
            doLogout();
          }}
        >
          {'Ok'}
        </LoadingButton>
      </div>
    </GenericModal>
  );
}
